import moment from 'moment';
import 'moment/min/locales';

const mobileLanguage = {
    'af': 'Afrikaans',
    'am': 'አማርኛ',
    'ar': 'عربي',
    'az': 'Azərbaycan dili',
    'be': 'Беларуская',
    'bg': 'Български',
    'bn': 'বাংলা',
    'bs': 'Bosanski',
    'ca': 'Català',
    'cs': 'Čeština',
    'da': 'Dansk',
    'de': 'Deutsch',
    'el': 'Ελληνικά',
    'en': 'English',
    'es': 'Español',
    'et': 'Eesti',
    'eu': 'Euskara',
    'fa': 'فارسی',
    'fi': 'Suomi',
    'fr': 'Français',
    'gl': 'Galego',
    'gu': 'ગુજરાતી',
    'he': 'עברית',
    'hi': 'हिन्दी',
    'hr': 'Hrvatski',
    'hu': 'Magyar',
    'hy': 'Հայերեն',
    'id': 'Bahasa Indonesia',
    'is': 'Íslenska',
    'it': 'Italiano',
    'ja': '日本語',
    'ka': 'ქართული',
    'kk': 'Қазақ тілі',
    'km': 'ខ្មែរ',
    'kn': 'ಕನ್ನಡ',
    'ko': '한국어',
    'ky': 'Кыргызча',
    'lo': 'ລາວ',
    'lt': 'Lietuvių',
    'lv': 'Latviešu',
    'mk': 'Македонски',
    'ml': 'മലയാളം',
    'mn': 'Монгол',
    'mr': 'मराठी',
    'ms': 'Bahasa Melayu',
    'my': 'မြန်မာဘာသာ',
    'ne': 'नेपाली',
    'nl': 'Nederlands',
    'or': 'ଓଡ଼ିଆ',
    'pa': 'ਪੰਜਾਬੀ',
    'pl': 'Polski',
    'pt': 'Português',
    'ro': 'Română',
    'ru': 'Русский',
    'si': 'සිංහල',
    'sk': 'Slovenčina',
    'sl': 'Slovenščina',
    'sq': 'Shqip',
    'sr': 'Српски',
    'sv': 'Svenska',
    'sw': 'Kiswahili',
    'ta': 'தமிழ்',
    'te': 'తెలుగు',
    'th': 'ภาษาไทย',
    'tl': 'Tagalog',
    'tr': 'Türkçe',
    'uk': 'Українська',
    'ur': 'اردو',
    'uz': 'Oʻzbekcha',
    'vi': 'Tiếng Việt',
    'zh': '中文 (简体)',
    'zh-HK': '中文 (香港)',
    'zh-TW': '中文 (繁體)',
    'zu': 'isiZulu'
};

const appLanguages = {
    'af': 'Afrikaans',
    'am': 'Amharic',
    'ar': 'Arabic',
    'az': 'Azerbaijani',
    'be': 'Belarusian',
    'bg': 'Bulgarian',
    'bn': 'Bengali',
    'bs': 'Bosnian',
    'ca': 'Catalan',
    'cs': 'Czech',
    'da': 'Danish',
    'de': 'German',
    'el': 'Greek',
    'en': 'English',
    'es': 'Spanish',
    'et': 'Estonian',
    'eu': 'Basque',
    'fa': 'Persian',
    'fi': 'Finnish',
    'fr': 'French',
    'gl': 'Galician',
    'gu': 'Gujarati',
    'he': 'Hebrew',
    'hi': 'Hindi',
    'hr': 'Croatian',
    'hu': 'Hungarian',
    'hy': 'Armenian',
    'id': 'Indonesian',
    'is': 'Icelandic',
    'it': 'Italian',
    'ja': 'Japanese',
    'ka': 'Georgian',
    'kk': 'Kazakh',
    'km': 'Khmer',
    'kn': 'Kannada',
    'ko': 'Korean',
    'ky': 'Kyrgyz',
    'lo': 'Lao',
    'lt': 'Lithuanian',
    'lv': 'Latvian',
    'mk': 'Macedonian',
    'ml': 'Malayalam',
    'mn': 'Mongolian',
    'mr': 'Marathi',
    'ms': 'Malay',
    'my': 'Burmese',
    'ne': 'Nepali',
    'nl': 'Dutch',
    'or': 'Odia',
    'pa': 'Punjabi',
    'pl': 'Polish',
    'pt': 'Portuguese',
    'ro': 'Romanian',
    'ru': 'Russian',
    'si': 'Sinhala',
    'sk': 'Slovak',
    'sl': 'Slovenian',
    'sq': 'Albanian',
    'sr': 'Serbian',
    'sv': 'Swedish',
    'sw': 'Swahili',
    'ta': 'Tamil',
    'te': 'Telugu',
    'th': 'Thai',
    'tl': 'Tagalog',
    'tr': 'Turkish',
    'uk': 'Ukrainian',
    'ur': 'Urdu',
    'uz': 'Uzbek',
    'vi': 'Vietnamese',
    'zh': 'Chinese (Simplified)',
    'zh-HK': 'Chinese (Hong Kong)',
    'zh-TW': 'Chinese (Traditional)',
    'zu': 'Zulu'
};

const localeAppLanguage = {
    ...appLanguages,
    'en-US': 'English',
    'it-IT': 'Italian',
    'fr-FR': 'French',
    'pt-PT': 'Portuguese',
    'cs-CZ': 'Czech'
}

const localeDict = {
    ...mobileLanguage,
    'en-US': 'English',
    'it-IT': 'Italiano',
    'fr-FR': 'Français',
    'pt-PT': 'Português',
    'cs-CZ': 'Čeština'
};

const localeData = {
    ...Object.keys(mobileLanguage).reduce((result, locale) => {
        result[locale] = locale;
        return result;
    }, {}),
    'en-US': 'en',
    'it-IT': 'it',
    'fr-FR': 'fr',
    'pt-PT': 'pt',
    'cs-CZ': 'cs'
};

export function formatMobileLanguage(locale) {
    return mobileLanguage[locale] || 'English';
}

const rtlLocateDict = ['he', 'ar', 'fa', 'ur'];

export function formatLocale(locale) {
    return localeDict[locale] || 'English';
}

export function formatLanguageName(locale) {
    return localeAppLanguage[locale] || 'English';
}

export function formatLocaleData(locale) {
    return localeData[locale] || 'en';
}

export function isRTL(locale) {
    return locale && rtlLocateDict.indexOf(locale) >= 0;
}

export function generateMomentLocaleSettings(locale) {
    var localeData = moment.localeData('en');
    let response = {
        ordinal: localeData.ordinal()
    };
    return response;
}


export function dateInternationalization(locale) {

    const localeCode = {
        'af': 'af',
        'am': 'am',
        'en-US': 'en',
        'ar': 'ar',
        'az': 'az',
        'be': 'be',
        'bg': 'bg',
        'bn': 'bn',
        'bs': 'bs',
        'ca': 'ca',
        'cs': 'cs',
        'cs-CZ': 'cs',
        'da': 'da',
        'de': 'de',
        'el': 'el',
        'en': 'en',
        'es': 'es',
        'et': 'et',
        'eu': 'eu',
        'fa': 'fa',
        'fi': 'fi',
        'fr': 'fr',
        'fr-FR': 'fr',
        'gl': 'gl',
        'gu': 'gu',
        'hi': 'hi',
        'hr': 'hr',
        'hu': 'hu',
        'hy': 'hy',
        'id': 'id',
        'is': 'is',
        'it': 'it',
        'it-IT': 'it',
        'ja': 'ja',
        'ka': 'ka',
        'kk': 'kk',
        'km': 'km',
        'kn': 'kn',
        'ko': 'ko',
        'ky': 'ky',
        'lo': 'lo',
        'lt': 'lt',
        'lv': 'lv',
        'mk': 'mk',
        'ml': 'ml',
        'mn': 'mn',
        'mr': 'mr',
        'ms': 'ms',
        'my': 'my',
        'ne': 'ne',
        'nl': 'nl',
        'or': 'or',
        'pa': 'pa',
        'pl': 'pl',
        'pt': 'pt',
        'pt-PT': 'pt',
        'ro': 'ro',
        'ru': 'ru',
        'si': 'si',
        'sk': 'sk',
        'sl': 'sl',
        'sq': 'sq',
        'sr': 'sr',
        'sv': 'sv',
        'sw': 'sw',
        'ta': 'ta',
        'te': 'te',
        'th': 'th',
        'tl': 'tl',
        'tr': 'tr',
        'uk': 'uk',
        'ur': 'ur',
        'uz': 'uz',
        'vi': 'vi',
        'zh': 'zh-cn',
        'zh-HK': 'zh-hk',
        'zh-TW': 'zh-tw',
        'zu': 'zu',
        'he': 'he'
    };

    if (locale == 'ar') {
        moment.updateLocale('ar', {
            ...moment.localeData('ar')._config,
            months: [
                'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
                'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
            ],
            monthsShort: [
                'ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون',
                'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس'
            ],
            weekdays: [
                'الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء',
                'الخميس', 'الجمعة', 'السبت'
            ],
            weekdaysShort: [
                'أحد', 'اثن', 'ثلث', 'أرب', 'خمي', 'جمع', 'سبت'
            ],
            weekdaysMin: [
                'ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'
            ],
            postformat: value => value
        });
        moment.locale('ar');
        return moment;
    }

    const momentLocale = localeCode[locale ? locale : 'en-US'] || 'en';
    moment.updateLocale(momentLocale, {
        postformat: value => value
    });
    moment.locale(momentLocale);
    return moment;
}
